import { render } from "./AdminPanel.vue?vue&type=template&id=397080df&ts=true"
import script from "./AdminPanel.vue?vue&type=script&lang=ts"
export * from "./AdminPanel.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__